import * as yup from "yup";
import { REGEX_SAFE_TEXT } from "utils/shared";

const requiredErrorMessage: string = "Required";
const invalidCharsErrorMessage: string = "Invalid characters are not allowed";

const ProfileValidationSchema = yup.object().shape({
  displayName: yup
    .string()
    .required(requiredErrorMessage)
    .matches(REGEX_SAFE_TEXT, invalidCharsErrorMessage),
  stewartAccessUsername: yup
    .string()
    .required(requiredErrorMessage)
    .matches(REGEX_SAFE_TEXT, invalidCharsErrorMessage),
  userTimeZone: yup
    .string()
    .required(requiredErrorMessage)
    .matches(REGEX_SAFE_TEXT, invalidCharsErrorMessage),
});

export default ProfileValidationSchema;
